// ─── src/chat/AuraLinkedText.jsx ─────────────────────────────────────────────
// Aura names places on this site and then leaves the couple to type them out.
// "The full edit is at /shop/wedding/shoes." rendered as plain text, so the one
// action her answer pointed at was the one thing she made harder to take.
//
// All the judgement lives in auraLinkText.js, which is tested directly — what does
// and does not become clickable in model-generated text is a security boundary.
// This file only renders the result, and renders it as React children rather than
// HTML, so anything markup-shaped in her output stays inert visible text.
//
// A plain anchor, like every other link in the chat surface (RecommendationCard
// does the same): this app has no client-side router. Opened in a new tab for the
// same reason "View Profile" is — the conversation stays alive behind it, and the
// attribution bridge now carries the Aura session across that boundary.
import { linkSegments } from './auraLinkText';

export default function AuraLinkedText({ text }) {
  if (!text || typeof text !== 'string') return null;

  const segments = linkSegments(text);
  if (!segments.some((s) => s.type === 'link')) return text;

  return segments.map((seg, i) => (
    seg.type === 'text' ? seg.value : (
      <span key={i}>
        <a
          href={seg.value}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'var(--lwd-gold, #d39a21)',
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
          }}
        >
          {seg.value}
        </a>
        {seg.trailing}
      </span>
    )
  ));
}
